import React, { useState } from 'react';
import { IntlMessages } from '../../../../helper/langHelper';
import { Form } from '../../LoginV2/Login.style';
import { create } from '../../../../services/bioplus-services/links';
import { Input, SwitchButtonWrapper, Tooltip } from '../dashboard.style';
import { v4 as uuidv4 } from 'uuid';

import { useMutation, useQueryClient } from 'react-query';
import ChildModal from '../../../../Components/uielements/modal/childModal';
import {
  ModalButtonWrapper,
  ModalGap,
  ModalWrapper,
  OutlineButton,
  SwitcherLabel,
} from '../../../../services/settings/appStyle/global.style';
import { Button, Loader, Switch } from '../../../../Components/uielements';
import { useUserContext } from '../../../../hooks/UserContext';

export const AddLinkModal = ({ onClose, isOpen }) => {
  const [linkValue, setLinkValue] = useState('');
  const [nameValue, setNameValue] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);

  const [isPrivate, setIsPrivate] = useState(true);
  const userContext = useUserContext();
  const roleId = userContext?.company?._id;

  const queryClient = useQueryClient();

  const mutation = useMutation((link, name) => create(link, name), {
    onSuccess: async () => {
      await queryClient.invalidateQueries('getLinks');
      setIsProcessing(false);
      onClose();
    },
    onError: (error) => {
      alert(error);
      setIsProcessing(false);
      onClose();
    },
  });

  const onSubmit = (e) => {
    e.preventDefault();
    // if (isValidURL(linkValue)) {
    //   setIsProcessing(true);
    //   mutation.mutate({ link: linkValue, name: nameValue });
    // } else {
    //   setIsProcessing(false);
    //   alert('Please enter a valid link.');
    // }
    setIsProcessing(true);
    mutation.mutate({
      link: isValidURL(linkValue),
      name: nameValue,
      localId: uuidv4(),
      roleId: roleId,
      privateFlag: isPrivate ? 1 : 0,
    });
  };

  const isValidURL = (url) => {
    const urlPattern = new RegExp(/^(ftp|http|https):\/\/[^ "]+$/i);

    // If the URL is already valid, return it
    if (urlPattern.test(url)) {
      return url;
    }

    // If the URL doesn't start with http, https, or ftp, add https://
    if (!/^((http|https|ftp):\/\/)/i.test(url)) {
      return `https://${url}`;
    }

    return url;
  };

  return (
    <>
      <ChildModal isOpen={isOpen} onClose={onClose} title={<IntlMessages id="modal.button.text" />}>
        <Form onSubmit={onSubmit}>
          <ModalWrapper>
            <ModalGap>
              <Input
                name="nameValue"
                placeholder="Provide a link name"
                value={nameValue}
                onChange={(e) => setNameValue(e.target.value)}
              />
              <Input
                name="linkValue"
                placeholder="Paste your link (ex- https://www.google.com)"
                value={linkValue}
                onChange={(e) => setLinkValue(e.target.value)}
              />
              {/* <SwitchButtonWrapper>
                <Switch handleToggle={() => setIsPrivate(!isPrivate)} checked={isPrivate} />
                <SwitcherLabel>Make it private ?</SwitcherLabel>
              </SwitchButtonWrapper> */}

              <SwitchButtonWrapper>
                <Switch handleToggle={() => setIsPrivate(!isPrivate)} checked={isPrivate} />
                <SwitcherLabel>Make it private?</SwitcherLabel>
                <Tooltip className="tooltip">For sensitive data, keep it private only.</Tooltip>
              </SwitchButtonWrapper>
            </ModalGap>
            <ModalButtonWrapper>
              <OutlineButton onClick={onClose}>
                <IntlMessages id="modal.button.cancel" />
              </OutlineButton>
              {isProcessing ? (
                <Button varient="normal" disabled={isProcessing}>
                  <div style={{ paddingRight: '10px' }}></div>
                  <IntlMessages id="button.text.processing" />
                  <Loader size="small" isNotRequiredLoadingText={true} />
                </Button>
              ) : (
                <Button varient="normal" type="submit">
                  <IntlMessages id="modal.button.text" />
                </Button>
              )}
            </ModalButtonWrapper>
          </ModalWrapper>
        </Form>
      </ChildModal>
    </>
  );
};

export default AddLinkModal;
